<template>
    <div class="container" id="container">
        <h3 class="title">
            {{user_key}}&nbsp;&nbsp;{{dateRangeTs.start_time | tsToDate}} ~ {{dateRangeTs.end_time | tsToDate}}调用记录
            <el-button type="primary" @click="back" size="mini">返回</el-button>
        </h3>
        <el-table
                :data="recordList"
                :height="tableHeight"
                :max-height="tableHeight"
                style="width: 100%;"
        >
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="remote_ip"
                    label="IP"
            >
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="path"
                    label="PATH"
            >
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    label="Connection time"
            >
                <template slot-scope="scope">
                    {{ scope.row.time | tsToDate }}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
  import dateRangePicker from "./dateRangePicker";
  import {apiGetApiRecord} from "@/api";
  import moment from "moment";

  export default {
    name: 'apiRecords',
    components: {
      // dateRangePicker
    },
    props: {
      user_key: {
        type: String
      },
      dateRangeTs: {
        type: Object
      }
    },
    data() {
      return {
        // currentKey: this.key,
        current_page: 1,
        page_size: 200,
        recordList: [],
        total: 0,
        tableHeight: 0
      }
    },
    created() {
      this.computedTableHeight()
    },
    mounted() {
      this.getApiCountList()
    },
    methods: {
      computedTableHeight() {
        this.tableHeight = document.body.offsetHeight - 100 - 50
      },
      back() {
        this.$router.go(-1)
      },
      handleChange(obj) {
        this.dateRangeTs = obj
      },
      async getApiCountList() {
        let {start_time, end_time} = this.dateRangeTs
        try {
          const res = await apiGetApiRecord(
            {
              user_key: this.user_key,
              page_num: this.current_page,
              per_page: this.page_size,
              start_time: this.dateRangeTs.start_time,
              end_time: this.dateRangeTs.end_time
            }
          );
          this.recordList = res.data
          this.total = res.total
        } catch (e) {
          console.log(e);
          this.$message.error('查询失败')
        }
      }
    },
    filters: {
      tsToDate(ts) {
        return moment(ts * 1000).format('YYYY-MM-DD')
      },
      tsToDateTime(ts) {
        return moment(ts * 1000).format('YYYY-MM-DD HH-mm-ss')
      }

    },
    computed: {},
    watch: {}
  }
</script>
<style lang="scss" scoped>

</style>
